export interface ActionLoadingState {
  loading: boolean;
  actionType: string;
}
